<script>
import {mapActions} from "pinia";
import {mainSearchStore} from "@/store/mainSearchStore";
import BaseLayout from "@/components/BaseLayout.vue";
import BaseSidebar from "@/components/BaseSidebar.vue";
import MainSearchControls from "@/components/MainSearch/MainSearchControls.vue";
import MainSearchResultList from "@/components/MainSearch/MainSearchResultList.vue";

export default {
  name: "MainSearchResultView",
  components: {
    BaseLayout,
    BaseSidebar,
    MainSearchControls,
    MainSearchResultList
  },
  methods: {
    ...mapActions(mainSearchStore, [
      'updateSearchParams',
    ]),
  },
  beforeUnmount() {
    this.updateSearchParams('searchString', '');
  }
}
</script>

<template>
<base-layout>
  <div class="main-search-wrap">
    <main-search-controls/>
    <main-search-result-list/>
  </div>
  <base-sidebar/>
</base-layout>
</template>

<style lang="scss">
.main-search-wrap {
  min-width: 600px;
  margin-right: 10px;
}

</style>